import { createSlice } from "@reduxjs/toolkit";
import storage from "web/script/utils/storage";
import environment from "web/script/modules/environment";

export interface EventCounterSlice {
    shouldBlockFilter: boolean;
    shouldBlockAll: boolean;
}

function readFromStorage(limit): boolean {
    const blockVariant = environment.getFeature("mg_block_on_event_counter");
    const eventCounter = storage.get("eventCounter", null, true);
    if (!eventCounter) {
        return false;
    }

    // if click event comes from action with count limit 2
    // e.g. filter open
    if (limit === 2) {
        if (
            (blockVariant === "hard_block" ||
                (blockVariant === "soft_block" && !eventCounter.hasBeenDismissed)) &&
            (eventCounter.countLimit3 >= 2 || eventCounter.countLimit2 >= 1)
        ) {
            return true;
        }
        return false;
    }
    if (
        (blockVariant === "hard_block" ||
            (blockVariant === "soft_block" && !eventCounter.hasBeenDismissed)) &&
        eventCounter.countLimit3 >= 2
    ) {
        return true;
    }

    return false;
}

function updateStorage({ category, action }): void {
    const eventCounter = storage.get("eventCounter", null, true)
        ? storage.get("eventCounter", null, true)
        : { countLimit3: 0, countLimit2: 0, hasBeenDismissed: false };

    // for filter click dont count the event on "filter close"
    if (
        (category === "app_overlay" && action === "modal_dismissed") ||
        (category === "send_to_app" && action === "continue_clicked")
    ) {
        eventCounter.hasBeenDismissed = true;
    } else if (category === "filter" && action == "open") {
        eventCounter.countLimit3++;
        eventCounter.countLimit2++;
    } else if (category !== "filter") {
        eventCounter.countLimit3 < 3 && eventCounter.countLimit3++;
    }
    // on every valid event update local storage
    storage.set("eventCounter", eventCounter, true);
}

const eventCountTracker = createSlice({
    name: "eventCounter",
    initialState: {
        shouldBlockFilter: readFromStorage(2),
        shouldBlockAll: readFromStorage(3),
    } as EventCounterSlice,
    reducers: {
        registerEvent(state, { payload }): void {
            updateStorage(payload);
            state.shouldBlockAll = readFromStorage(3);
            state.shouldBlockFilter = readFromStorage(2);
        },
    },
});

export const { registerEvent } = eventCountTracker.actions;
export default eventCountTracker.reducer;
